import BaseClient from './BaseClient';

class AdminFeaturesClient extends BaseClient {
    getFeatures(teamId) {
        const url = `/api/admin/teams/${teamId}/features`;
        return this.makeCoreApiRequest(url);
    }

    enableFeature(teamId, featureId) {
        const url = `/api/admin/teams/${teamId}/features/${featureId}`;
        return this.makeCoreApiRequest(url, 'post');
    }

    disableFeature(teamId, featureId) {
        const url = `/api/admin/teams/${teamId}/features/${featureId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }
}

export default new AdminFeaturesClient();
